module.exports = __webpack_public_path__ + "img/chongdianapp.3c8f72a3.png";